export enum DocumentEditorNotificationScope {
  WIDGET_ACTION = 'WIDGET_ACTION',
  INITIALIZATION = 'INITIALIZATION',
  TRIGGER = 'TRIGGER'
}
